module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t("profile.edit.yourDocuments")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("profile.kyc.regularKycInfo")))]), _vm._v(" "), (_vm.kycDocument.Id) ? _c('kyc-status', {
    attrs: {
      "kycDocument": _vm.kycDocument
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.documentsSubmitted) ? _c('button', {
    staticClass: "btn btn-default btn-lg button-wide-crowd mb-0 uppercase",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.open
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("profile.edit.addDocuments")))])]) : _vm._e(), _vm._v(" "), (_vm.kycDocument.Id) ? _c('button', {
    staticClass: "btn btn-default btn-lg button-wide-crowd mb-0 uppercase",
    attrs: {
      "type": "button",
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.checkDocumentsStatus
    }
  }, [(!_vm.processing) ? _c('span', [_vm._v(_vm._s(_vm.$t("profile.edit.checkStatus")))]) : _vm._e(), _vm._v(" "), _c('clip-loader', {
    attrs: {
      "loading": _vm.processing,
      "color": '#fff',
      "size": "17px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.kycDocument.Status === 'CREATED') ? _c('button', {
    staticClass: "btn btn-default btn-lg button-wide-crowd mb-0 uppercase",
    attrs: {
      "type": "button",
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.submitDocuments
    }
  }, [(!_vm.processing) ? _c('span', [_vm._v(_vm._s(_vm.$t("profile.kyc.submitForVerification")))]) : _vm._e(), _vm._v(" "), _c('clip-loader', {
    attrs: {
      "loading": _vm.processing,
      "color": '#fff',
      "size": "17px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.modalOpen) ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendDocuments()
      }
    }
  }, [_c('modal', {
    staticClass: "modal-wide",
    attrs: {
      "close": _vm.close
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t("profile.edit.addDocuments")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("profile.edit.documentInfo")))]), _vm._v(" "), (_vm.errors.kyc) ? _c('p', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.errors.kyc))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "documents__list"
  }, _vm._l((_vm.documents), function(file, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-4 col-md-3"
    }, [_c('div', {
      staticClass: "documents__item"
    }, [(file.base64.includes('data:application/pdf')) ? _c('embed', {
      attrs: {
        "src": file.base64,
        "width": "100%"
      }
    }) : _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": file.base64,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "remove-documents",
      on: {
        "click": function($event) {
          return _vm.removeDocument(_vm.documents, index)
        }
      }
    }, [_vm._v("×")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(file.name))])])
  }), 0), _vm._v(" "), _c('upload-base64', {
    ref: "file_input",
    staticClass: "btn btn-default",
    attrs: {
      "multiple": false,
      "done": _vm.addFiles
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default button-wide-crowd",
    attrs: {
      "type": "button",
      "disabled": _vm.processing
    },
    on: {
      "click": function($event) {
        return _vm.$refs.file_input.$refs.input.click();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('profile.kyc.addDocuments')) + "\n          ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100px",
      "margin": "5px"
    },
    attrs: {
      "slot": "footer",
      "type": "submit",
      "disabled": _vm.processing
    },
    slot: "footer"
  }, [(!_vm.processing) ? _c('span', [_vm._v(_vm._s(_vm.$t("send")))]) : _vm._e(), _vm._v(" "), _c('clip-loader', {
    attrs: {
      "loading": _vm.processing,
      "color": '#fff',
      "size": "17px"
    }
  })], 1)])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-326f16ad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/Kyc.vue
// module id = 794
// module chunks = 1